import { USERROLES } from "./roles-constant";

/**
 * Local-only mock authentication.
 *
 * The sales-site auth backend is not always reachable from a dev machine, which
 * makes the internal (post-login) screens impossible to review. When
 * REACT_APP_ENABLE_MOCK_AUTH is "true" the sign-in form resolves the accounts
 * below locally instead of calling the auth API.
 *
 * This is a review/QA aid only - keep the flag out of every deployed .env.
 */
export const MOCKAUTHENABLED = process.env.REACT_APP_ENABLE_MOCK_AUTH === "true";

/** Marks a session as locally issued so the API layer never tries to refresh it. */
export const MOCKAUTHTOKENPREFIX = "mock-auth.";

export const MOCKAUTHACCOUNTS = [
  {
    email: "business@yopmail.com",
    password: "Admin@123",
    role: USERROLES.ROLEPRIORITY2,
    user: {
      userId: "mock-business-user",
      id: "mock-business-user",
      email: "business@yopmail.com",
      firstName: "Business",
      lastName: "Reviewer",
      defaultRole: USERROLES.ROLEPRIORITY2,
      phoneNumber: "+44 7700 900001",
      country: "United Kingdom",
      city: "London",
      profileImage: "",
      isEmailVerified: true,
      isKycVerified: true,
    },
  },
  {
    email: "personal@yopmail.com",
    password: "Admin@123",
    role: USERROLES.ROLEPRIORITY3,
    user: {
      userId: "mock-personal-user",
      id: "mock-personal-user",
      email: "personal@yopmail.com",
      firstName: "Personal",
      lastName: "Reviewer",
      defaultRole: USERROLES.ROLEPRIORITY3,
      phoneNumber: "+44 7700 900002",
      country: "United Kingdom",
      city: "Manchester",
      profileImage: "",
      isEmailVerified: true,
      isKycVerified: true,
    },
  },
];
